const SignUpConfigs = [
  {
    name: "Nama",
    field: "name",
    type: "text_plain",
  },
  {
    name: "User Name",
    field: "username",
    type: "text_plain",
  },
  {
    name: "Password",
    field: "password",
    default_value: "",
    default_value_on_edit: true,
    type: "text_password",
  },
  {
    name: "Konfirmasi Password",
    field: "cpassword",
    default_value: "",
    default_value_on_edit: true,
    type: "text_password",
  },
];

export default SignUpConfigs;
